import { render, staticRenderFns } from "./UrlJump.vue?vue&type=template&id=662e0c92"
import script from "./UrlJump.vue?vue&type=script&lang=js"
export * from "./UrlJump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports